import { Box } from '@mui/material'

import { currencyMask } from '@utils/masks/currencyMask'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { DetailedSummaryV2TotalProps } from '../context/types'

function fmt(value: number | null | undefined): string {
  if (value == null) return '-'
  return currencyMask(value.toFixed(2)) || '-'
}

function cell(content: string) {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      {content}
    </Box>
  )
}

interface ParseDetailedSummaryTotalGridProps {
  total: DetailedSummaryV2TotalProps | null | undefined
}

export const parseDetailedSummaryTotalGrid = ({
  total,
}: ParseDetailedSummaryTotalGridProps): ColumnDefProps[][] => {
  if (!total) return []

  return [
    [
      {
        id: 'description',
        columnName: 'Categorias',
        fontWeight: 700,
        value: 'Total',
      },
      {
        id: 'realized',
        columnName: 'Realizado',
        align: 'center',
        fontWeight: 700,
        withoutTooltip: true,
        value: cell(fmt(total.realized)),
      },
      {
        id: 'projection',
        columnName: 'Projeção',
        align: 'center',
        fontWeight: 700,
        withoutTooltip: true,
        value: cell(fmt(total.projection)),
      },
      {
        id: 'adjustment',
        columnName: 'Ajuste',
        align: 'center',
        fontWeight: 700,
        withoutTooltip: true,
        value: cell(fmt(total.adjustment)),
      },
      {
        id: 'finalPreview',
        columnName: 'Prévia Final',
        align: 'center',
        fontWeight: 700,
        withoutTooltip: true,
        value: cell(fmt(total.finalPreview)),
      },
      {
        id: 'historicalAverage',
        columnName: 'Média Hist.',
        align: 'center',
        fontWeight: 700,
        withoutTooltip: true,
        value: cell(fmt(total.historicalAverage)),
      },
      {
        id: 'deviationVsAverage',
        columnName: 'Desvio vs Média',
        align: 'center',
        withoutTooltip: true,
        value: cell(''),
      },
      {
        id: 'action',
        columnName: 'Ações',
        align: 'center',
        minWidth: '5rem',
        maxWidth: '5rem',
        stickyPosition: 'right',
        withoutTooltip: true,
        value: <></>,
      },
    ],
  ]
}
